<template>
	<div class="getReport">
		<!-- 设置系统通知 -->
		<div @click="setEmailNotice" class="email-notice">
			<img src="@/assets/systemImg/set_email.png" alt="设置系统通知图标" />
			<span>设置系统通知</span>
		</div>

		<div class="step">
			<p class="stepTit">预约信息</p>
			<div class="groupS">
				<el-row :gutter="20">
					<el-col :span="9">
						<div class="groupList">
							<label>
								<span>预约日期：</span>
								<el-date-picker
									v-model="dateValue"
									value-format="timestamp"
									prefix-icon="clearDateIcon"
									type="daterange"
									range-separator="~"
									start-placeholder="开始日期"
									end-placeholder="结束日期"
									:default-value="defaultDate()"
								></el-date-picker>
							</label>
							<!--                            <p class="ErrorTip" v-show="phone">手机号码输入错误</p>-->
						</div>
					</el-col>
					<el-col :span="8">
						<div class="groupList">
							<label>
								<span>预约状态：</span>
								<el-select v-model="value" class="state" placeholder="请选择">
									<el-option v-for="item in options" class="state-option" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</label>
							<!--                            <p class="ErrorTip" v-show="phone">手机号码输入错误</p>-->
						</div>
					</el-col>
					<el-col :span="6"><button class="nextBtn" @click="getReport">开始筛选</button></el-col>
				</el-row>

				<div style="clear: both;"></div>
			</div>
		</div>
		<div class="step">
			<p class="stepTit">客户评估报告</p>
			<el-table
				ref="multipleTable"
				:data="tableData"
				tooltip-effect="dark"
				style="width: 100%"
				@selection-change="handleSelectionChange"
				:header-cell-style="{ fontWeight: 600 }"
				border
			>
				<el-table-column prop="created_at" label="预约时间" :width="createdTimeW"></el-table-column>
				<el-table-column prop="is_finish" label="状态" :width="finishW"></el-table-column>
				<el-table-column prop="mobile" label="手机号码" :width="phoneW"></el-table-column>
				<el-table-column prop="idcard" label="身份证号" :width="identW">
					<template slot-scope="scope">
						<div style="text-align: center;">
							{{ scope.row.idcard ? scope.row.idcard : '--'}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="package" label="开通套餐" :width="packageW"></el-table-column>
				<el-table-column prop="timeOne" label="第一预约信息">
					<template slot-scope="scope">
						<div style="display: flex;">
							<div>
								{{ scope.row.atime }}
								<br />
								{{ scope.row.address }}
							</div>
							<div style="clear: both;"></div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="timeTwo" label="第二预约信息">
					<template slot-scope="scope">
						<div style="display: flex;">
							<div>
								{{ scope.row.atime2 }}
								<br />
								{{ scope.row.address2 }}
							</div>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div style="width: 100%;margin-top: 0.24rem"></div>
			<el-row :gutter="20" v-show="downFile">
				<el-col :span="12">
					<button type="submit" class="download-excel nextBtn" @click="downExcel">下载成excel文件</button>
					<form :action="http" method="post" autocomplete="off" v-show="false">
						<input type="text" name="startat" :value="dateValue[0] / 1000" />
						<input type="text" name="endat" :value="dateValue[1] / 1000" />
						<input type="text" name="type" :value="value" />
						<button type="submit" ref="down">下载成excel文件</button>
					</form>
				</el-col>
			</el-row>
			<div class="pag">
				<el-pagination hide-on-single-page @current-change="handleCurrentChange" layout="prev, pager, next" :page-size="10" :total="pageCount"></el-pagination>
			</div>
		</div>
		<div class="editPopup" v-if="ifEdit">
			<div class="editBox">
				<div class="closeEdit" @click="closeEdit"></div>
				<div class="editTitle">第一预约信息：</div>
				<div class="editGroup">
					<span>进行体检的地点：</span>
					<div style="position: relative">
						<p class="iconfont icon-zhiyuandidian"></p>
						<select id="areaSel" v-model="areaValue" @change="areaValueChange = true" :class="{ 'is-change': areaValueChange }">
							<!-- <option value="">请选择</option> -->
							<option v-for="(item, index) in areaBookinglist" :value="item.id">{{ item.name }}</option>
						</select>
					</div>
				</div>
				<div class="editGroup">
					<span>进行体检的日期与时间：</span>
					<div style="position: relative">
						<el-date-picker
							v-model="dateEdit"
							type="date"
							size="large"
							:default-value="showDate"
							value-format="timestamp"
							placeholder="选择日期"
							:class="{ 'is-change': dateEditChange }"
							@change="dateChange"
							:picker-options="pickerOptions"
						></el-date-picker>
						<el-time-select
							v-model="timeEdit"
							:picker-options="{
								start: '09:00',
								step: '00:15',
								end: '12:30'
							}"
							:class="{ 'is-change': timeEditChange }"
							@change="timeEditChange = true"
							placeholder="选择时间"
							value-format="timestamp"
						></el-time-select>
					</div>
					<div style="clear: both;"></div>
				</div>
				<button type="submit" class="nextBtn" style="margin: 0 auto; padding: 0 0.5rem;margin-top: 0.4rem" @click="confirmEdit">确认修改</button>
			</div>
		</div>

		<Alertb :hidden="alertShow" :tip-status="tipStatus" :tip-text="tipText" @on-close="closeDialog" @on-confirm="confirmDialog" />

		<!-- 设置系统通知 -->
		<el-dialog 		  :close-on-click-modal="false" class="notice-alert" top="0" :visible.sync="emailNotice" :show-close="false" width="8.5rem">
			<img @click="emailNotice = false" src="@/assets/icons/close.png" class="alert-close" alt="" />
			<div>
				<h6>保存信息</h6>
				<p>若有新的客户完成套餐购买与预约，将会发送电邮至指定邮箱提醒您进行处理。</p>
				<p>若您填写了手机号码，同时亦会有短讯通知。</p>
				<div class="form">
					<div v-for="(email, index) in emailNoticeVal" :key="index" class="emails">
						<label :for="index > 0 ? 'emailNoticeVal' + (index + 1) : 'emailNoticeVal'">
							<span v-if="index == 0">*</span>
							邮箱地址{{ index > 0 ? index + 1 : '' }}：
						</label>
						<el-input
							:id="index > 0 ? 'emailNoticeVal' + (index + 1) : 'emailNoticeVal'"
							class="emailNoticeVal"
							v-model="email.value"
							@blur="emailVerify(email.value)"
							:placeholder="'请填写您需要接收通知的邮箱号码' + (index > 0 ? '（选填）' : '（必填）')"
						/>
						<i v-if="index > 0" @click="removeEmail(index)" class="el-icon-remove-outline"></i>
					</div>
					<div>
						<label for=""></label>
						<span @click="addEmail" class="add-email">+新增邮箱地址</span>
					</div>
					<div>
						<label for="emailNoticeTel">手机号：</label>
						<el-input @input="onlyNumber" @blur="phoneVerify" id="emailNoticeTel" v-model="emailNoticeTel" placeholder="请填写您需要接收通知的手机号码（选填）">
							<el-select v-model="telArea" class="tel-area" slot="prepend">
								<el-option :value="852"></el-option>
								<el-option :value="86"></el-option>
							</el-select>
						</el-input>
						<label for="emailNoticeTel">验证码：</label>
						<el-input id="emailNoticeCode" v-model="emailNoticeCode" placeholder="请填写验证码" maxlength="4" />
						<el-button :class="{ sending: codeSending }" class="send-code" type="primary" :disabled="codeSending">
							<span v-if="!codeSending" @click="sendEmailCode">发送验证码</span>
							<span v-else>{{ countDown }}秒后重新获取</span>
						</el-button>
					</div>
					<el-button @click="saveInfo" class="save-notice" type="primary">保存信息</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import bookingInfo from '@/assets/js/bookingInfo';
import Alertb from '@/components/alertb';

export default {
	components: {
		Alertb
	},
	name: 'bookingInfo',
	...bookingInfo
};
</script>

<style scoped>
.getReport >>> .el-pager li.active {
	color: white;
	border-radius: 0.02rem;
	background: #6681fa !important;
}

.getReport >>> .el-range-editor.el-input__inner {
	float: left;
	width: 3.2rem;
	height: 0.36rem;
	line-height: 0.36rem !important;
	padding: 0;
}

.getReport >>> .el-date-editor .el-range-separator {
	line-height: 0.36rem !important;
}
.getReport >>> .el-select {
	float: left;
}
.getReport >>> .el-pagination {
	text-align: center;
}
.editPopup >>> .el-select-dropdown__item {
	text-indent: 15px !important;
}
.editPopup >>> .el-input {
	margin-top: 0.07rem;
	display: block;
	float: left;
	width: 2.42rem;
	height: 0.4rem;
	font-size: 0.14rem;
}
.editPopup >>> .el-input:last-child {
	float: right;
}
.editPopup >>> .el-input__icon {
	margin: 0 0.07rem;
	line-height: 0.4rem;
}
.editPopup >>> .el-input__inner {
	height: 0.4rem;
	border: 0.01rem solid rgba(213, 216, 222, 1);
	text-indent: 0.1rem;
	color: #c0c4cc;
}
.getReport >>> .el-range-input {
	font-size: 0.14rem;
	line-height: 0.36rem;
}

.is-change >>> .el-input__inner,
.is-change#areaSel {
	color: #40444d !important;
}
.state >>> .el-input__inner {
	font-size: 0.14rem;
	height: 0.36rem;
	line-height: 0.36rem;
}
.state >>> .el-input__icon {
	line-height: 0.36rem;
}

/* 设置邮箱弹出框 */
.notice-alert >>> .el-dialog {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	margin: 0;
}
.notice-alert >>> .el-dialog__header {
	padding: 0;
}
.notice-alert >>> .el-dialog__body {
	padding: 0.24rem;
}
.notice-alert >>> .el-input input {
	height: 0.36rem;
	line-height: 0.36rem;
	margin-bottom: 0.08rem;
	padding: 0 0.08rem;
	font-weight: bold;
}
.notice-alert .emailNoticeVal >>> input {
	width: 7.08rem;
}
.notice-alert >>> #emailNoticeTel {
	display: inline-block;
	width: 3rem;
	margin-right: 0.09rem;
	vertical-align: top;
}
.notice-alert >>> #emailNoticeCode {
	width: 1.38rem;
	vertical-align: middle;
}
.notice-alert >>> .el-input-group__prepend {
	display: inline-block;
	width: 0.6rem;
	height: 0.35rem;
	padding: 0;
	background-color: #fff;
}
.notice-alert >>> .el-select__caret.el-input__icon {
	position: relative;
	height: 0.35rem;
}
.notice-alert >>> .el-select__caret.el-input__icon:before {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	line-height: 0.36rem;
}
.el-select-dropdown__item {
	padding: 0 0.08rem;
}
.notice-alert >>> .el-input.is-active .el-input__inner,
.notice-alert >>> .el-input__inner:focus {
	border-color: #6681fa;
}
</style>
<style src="@/assets/iconFonts/iconfont.css" scoped></style>
<style src="@/assets/css/bookingInfo.css" scoped></style>
